import React, { useEffect, useState } from "react";
import { Alert, Button, Snackbar, TextField } from "@mui/material";
import "./style.scss";
import { getEsignFormStatus } from "../../API/api";

const EmailValidationPopup = ({ recipientId, handleClose }) => {
  const [email, setEmail] = useState('');
  const [recipientEmail, setRecipientEmail] = useState('')
  const [emailError, setEmailError] = useState({ isError: false, msg: '' })
  const [isEmailVerified, setIsEmailVerified] = useState(false);

  const getEmailFromForm = async () => {
    try {
      const res = await getEsignFormStatus(recipientId);
      if (res?.data?.data?.email) {
        setRecipientEmail(res?.data?.data?.email)
      }
    } catch (error) {
      console.log('Error to get esign form status', error)
    }
  }

  const handleVerifyEmail = () => {
    if (email) {
      if (recipientEmail === email) {
        setIsEmailVerified(true);
        setTimeout(() => {
          handleClose();
        }, 1000)
      } else {
        setEmailError({
          isError: true,
          msg: 'Email does not match'
        })
      }
    } else {
      setEmailError({
        isError: true,
        msg: 'Please enter your email'
      })
    }
  }

  useEffect(() => {
    if (recipientId) {
      getEmailFromForm()
    }
  }, [recipientId])

  return (
    <div className="confirmation-container">
      <div className="header">Email Verification</div>
      <div className="email-container">
        <div className="email-text">Verify your email</div>
        <TextField
          id="filled-basic"
          placeholder="Enter your email address"
          variant="filled"
          className="email-validation-field"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value)
            if (emailError?.isError) {
              setEmailError({
                isError: false,
                msg: ''
              })
            }
          }}
          onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }}
          error={emailError?.isError}
          helperText={emailError?.msg}
        />
      </div>
      <div className="button-container">
        <Button variant="contained" className="btn-yes" sx={{ px: 6 }} onClick={handleVerifyEmail}>
          Verify
        </Button>
      </div>
      <Snackbar
          open={isEmailVerified}
          autoHideDuration={1000}
          onClose={() => setIsEmailVerified(false)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
          <Alert onClose={() => setIsEmailVerified(false)} severity="success">
            Email successfully verified.
          </Alert>
      </Snackbar>
    </div>
  );
};

export default EmailValidationPopup;
